import { CountryAutocompleteField, DirectoryAutocompleteField } from 'features';
import { AutocompleteField } from 'libs/form/fields/AutocompleteField';
import { DatePickerField } from 'libs/form/fields/DatePickerField';
import { DecimalField } from 'libs/form/fields/DecimalField';
import { NumberField } from 'libs/form/fields/NumberField';
import { TextField } from 'libs/form/fields/TextField';

import { FieldConfig } from '../../types';

export interface RecordFieldProps {
  readOnly?: boolean;
  fieldConfig: FieldConfig;
}

export const RecordField = ({ fieldConfig, readOnly }: RecordFieldProps) => {
  const showRequiredMark = fieldConfig.isRequired;

  switch (fieldConfig.component) {
    case 'Input':
      if (fieldConfig.inputFieldConfig?.isNumber) {
        return (
          <NumberField
            allowSubmit
            fullWidth
            format={(v) => {
              const value = !v ? v : Number(v);
              if (Number.isNaN(value as number)) {
                return undefined;
              }
              return value;
            }}
            label={fieldConfig.label}
            maxLength={fieldConfig.inputFieldConfig?.maxLength}
            maxNumber={fieldConfig.inputFieldConfig?.maxNumber}
            name={fieldConfig.name}
            placeholder={fieldConfig.placeholder}
            readOnly={readOnly}
            showRequiredMark={showRequiredMark}
          />
        );
      }
      return (
        <TextField
          allowSubmit
          fullWidth
          label={fieldConfig.label}
          maxLength={fieldConfig.inputFieldConfig?.maxLength}
          name={fieldConfig.name}
          placeholder={fieldConfig.placeholder}
          readOnly={readOnly}
          showRequiredMark={showRequiredMark}
        />
      );

    case 'Decimal':
      return (
        <DecimalField
          allowSubmit
          fullWidth
          label={fieldConfig.label}
          maxFloatingPoints={fieldConfig.decimalFieldConfig?.maxFloatingPoints}
          maxIntegerLength={fieldConfig.decimalFieldConfig?.maxIntegerLength}
          name={fieldConfig.name}
          placeholder={fieldConfig.placeholder}
          readOnly={readOnly}
          showRequiredMark={showRequiredMark}
        />
      );

    case 'Datetime':
      return (
        <DatePickerField
          fullWidth
          disableFuture={false}
          label={fieldConfig.label}
          maxDate={fieldConfig.datePickerFieldConfig?.maxDate}
          minDate={fieldConfig.datePickerFieldConfig?.minDate}
          name={fieldConfig.name}
          placeholder={fieldConfig.placeholder}
          readOnly={readOnly}
          showRequiredMark={showRequiredMark}
        />
      );

    case 'Select':
      return (
        <AutocompleteField
          fullWidth
          label={fieldConfig.label}
          name={fieldConfig.name}
          optionLabelKey={
            fieldConfig.selectFieldConfig?.optionLabelKey ?? 'label'
          }
          options={fieldConfig.selectFieldConfig?.options ?? []}
          optionValueKey={
            fieldConfig.selectFieldConfig?.optionValueKey ?? 'value'
          }
          placeholder={fieldConfig.placeholder}
          readOnly={readOnly}
          showRequiredMark={showRequiredMark}
        />
      );

    case 'Country':
      return (
        <CountryAutocompleteField
          fullWidth
          label={fieldConfig.label}
          name={fieldConfig.name}
          placeholder={fieldConfig.placeholder}
          readOnly={readOnly}
          showRequiredMark={showRequiredMark}
        />
      );
    case 'Directory':
      return (
        <DirectoryAutocompleteField
          fullWidth
          directorySchemaName={
            fieldConfig.directoryFieldConfig?.directorySchemaName!
          }
          fieldName={fieldConfig.directoryFieldConfig?.fieldName!}
          label={fieldConfig.label}
          name={fieldConfig.name}
          placeholder={fieldConfig.placeholder}
          readOnly={readOnly}
          showRequiredMark={showRequiredMark}
        />
      );

    default:
      return null;
  }
};
